import SectionCard from "@/components/SectionCard";
import AreaChart from "@/components/charts/AreaChart";

export default function PanelEvolucion({ evolucion }) {
  return (
    <SectionCard
      title="Evolución de conversión"
      subtitle="Conversión global últimos 12 meses · Datos reales (PRM × DG)"
      testid="panel-evolucion"
    >
      <AreaChart
        categories={evolucion.map((e) => e.mes)}
        series={[{ name: "Conversión %", data: evolucion.map((e) => e.conversion) }]}
        colors={["#7C3AED"]}
        height={240}
      />
    </SectionCard>
  );
}
